import http from "src/services/http";
import queryString from "query-string";
import store from "src/store";
import * as types from "../types/produtos";

export const salvarProduto = () => {
  const { produto_filtro, produto } = store.getState().produtos;
  return new Promise((resolve, reject) => {
    if (produto.id > 0) {
      http.put(`/api/v2/empresa/produtos/${produto.id}`, { ...produto }).then(
        (response) => {
          store.dispatch([
            { type: types.LOADING_DELIV_PRODUTO, payload: true },
            pesquisarProdutos(produto_filtro),
          ]);
          resolve(produto.id);
        },
        (error) => {
          store.dispatch([
            { type: types.LOADING_DELIV_PRODUTO, payload: false },
          ]);
          reject(error);
        }
      );
    } else {
      http.post(`/api/v2/empresa/produtos`, { ...produto }).then(
        (response) => {
          store.dispatch(pesquisarProdutos(produto_filtro));
          const { id } = response.data;
          if (produto.galeria_imagens === "1") {
            resolve(id);
          } else {
            resolve();
          }
        },
        (error) => {
          store.dispatch([
            { type: types.LOADING_DELIV_PRODUTO, payload: false },
          ]);
          reject(error);
        }
      );
    }
  });
};

export const pesquisarProdutos = (filtro) => {
  const qry = queryString.stringify(filtro, { arrayFormat: "index" });
  return (dispatch) => {
    http.get(`/api/v2/empresa/produtos?${qry}`).then(
      (resp) => {
        const { total, current_page: page, per_page, data } = resp.data;
        dispatch([
          { type: types.LOAD_DELIV_PRODUTOS, payload: data },
          { type: types.SET_PAGE_DELIV_PRODUTO, payload: parseInt(page) },
          { type: types.SET_TOTAL_DELIV_PRODUTO, payload: parseInt(total) },
          {
            type: types.SET_PERPAGE_DELIV_PRODUTO,
            payload: parseInt(per_page),
          },
          { type: types.LOADING_DELIV_PRODUTO, payload: false },
        ]);
      },
      (error) => {
        dispatch([{ type: types.LOADING_DELIV_PRODUTO, payload: false }]);
      }
    );
  };
};

export const excluirProduto = () => {
  const { produto_filtro, produto } = store.getState().produtos;
  return new Promise((resolve, reject) => {
    http.delete(`/api/v2/empresa/produtos/${produto.id}`).then(
      (response) => {
        store.dispatch([
          { type: types.LOADING_DELIV_PRODUTO, payload: true },
          {
            type: types.SET_DELIV_PRODUTO,
            payload: { titulo: "", descricao: "", icone: "" },
          },
          pesquisarProdutos(produto_filtro),
        ]);
        resolve();
      },
      (error) => {
        store.dispatch([{ type: types.LOADING_DELIV_PRODUTO, payload: false }]);
        reject(error);
      }
    );
  });
};

export const inserirProdutoCompl = (complemento) => {
  return new Promise((resolve, reject) => {
    http.post("/api/v2/empresa/produto/complementos", complemento).then(
      (response) => {
        store.dispatch([{ type: types.LOADING_DELIV_PRODUTO, payload: false }]);
        resolve({ id: 0 });
      },
      (error) => {
        store.dispatch([{ type: types.LOADING_DELIV_PRODUTO, payload: false }]);
        reject(error);
      }
    );
  });
};

export const atualizarProdutoCompl = ({ id, ...complemento }) => {
  return new Promise((resolve, reject) => {
    http.put(`/api/v2/empresa/produto/complementos/${id}`, complemento).then(
      (response) => {
        store.dispatch([{ type: types.LOADING_DELIV_PRODUTO, payload: false }]);
        resolve({ id: 0 });
      },
      (error) => {
        store.dispatch([{ type: types.LOADING_DELIV_PRODUTO, payload: false }]);
        reject(error);
      }
    );
  });
};

export const pesquisarProdutosCompl = (filtro) => {
  const qry = queryString.stringify(filtro, {
    arrayFormat: "index",
  });

  return (dispatch) => {
    http.get(`/api/v2/empresa/produto/complementos?${qry}`).then(
      (resp) => {
        dispatch([
          {
            type: types.SET_CONTROLAR_ESTOQUE,
            payload: resp.data.controlar_estoque,
          },
          {
            type: types.LOAD_DELIVE_PRODUTO_COMPLEMENTOS,
            payload: resp.data.complementos,
          },
          { type: types.LOADING_DELIV_PRODUTO, payload: false },
        ]);
      },
      (error) => {
        dispatch([{ type: types.LOADING_DELIV_PRODUTO, payload: false }]);
      }
    );
  };
};

export const excluirProdutoCompl = (id) => {
  return new Promise((resolve, reject) => {
    http.delete(`/api/v2/empresa/produto/complementos/${id}`).then(
      (response) => {
        store.dispatch([{ type: types.LOADING_DELIV_PRODUTO, payload: false }]);
        resolve({ id: 0 });
      },
      (error) => {
        store.dispatch([{ type: types.LOADING_DELIV_PRODUTO, payload: false }]);
        reject(error);
      }
    );
  });
};

export const pesquisarCategorias = (filtro) => {
  const qry = queryString.stringify(filtro, { arrayFormat: "index" });
  return (dispatch) => {
    http.get(`/api/v2/empresa/produto/categorias?${qry}`).then(
      (resp) => {
        const { total, current_page: page, per_page, data } = resp.data;
        dispatch([
          { type: types.LOAD_DELIV_CATEGORIAS, payload: data },
          { type: types.SET_PAGE_DELIV_CATEGORIA, payload: page },
          { type: types.SET_TOTAL_DELIV_CATEGORIA, payload: total },
          { type: types.SET_PERPAGE_DELIV_CATEGORIA, payload: per_page },
        ]);
      },
      (error) => {}
    );
  };
};

export const salvarcomplemento = () => {
  const { complemento_filtro, complemento } =
    store.getState().empresa_complementos;
  return new Promise((resolve, reject) => {
    if (complemento.id > 0) {
      http
        .put(`/api/v2/empresa/produto/complementos/${complemento.id}`, {
          ...complemento,
        })
        .then(
          (response) => {
            store.dispatch([
              { type: types.LOADING_COMPLEMENTO, payload: true },
              pesquisarComplementos(complemento_filtro),
            ]);
            resolve({ id: 0 });
          },
          (error) => {
            store.dispatch([
              { type: types.LOADING_COMPLEMENTO, payload: false },
            ]);
            reject(error);
          }
        );
    } else {
      http
        .post(`/api/v2/empresa/produto/complementos`, { ...complemento })
        .then(
          (response) => {
            store.dispatch([pesquisarComplementos(complemento_filtro)]);
            const { id } = response.data;
            if (complemento.galeria_imagens == 1) {
              resolve({ id, base64: complemento.base64 });
            } else {
              resolve({ id: 0 });
            }
          },
          (error) => {
            store.dispatch([
              { type: types.LOADING_COMPLEMENTO, payload: false },
            ]);
            reject(error);
          }
        );
    }
  });
};

export const pesquisarComplementos = (filtro) => {
  const qry = queryString.stringify(filtro, { arrayFormat: "index" });
  return (dispatch) => {
    http.get(`/api/v2/empresa/complementos?${qry}`).then(
      (resp) => {
        const { total, current_page: page, per_page, data } = resp.data;
        dispatch([
          { type: types.LOAD_COMPLEMENTOS, payload: data },
          { type: types.SET_PAGE_COMPLEMENTO, payload: page },
          { type: types.SET_TOTAL_COMPLEMENTO, payload: total },
          { type: types.SET_PERPAGE_COMPLEMENTO, payload: per_page },
          { type: types.LOADING_COMPLEMENTO, payload: false },
        ]);
      },
      (error) => {
        console.log(error);
        dispatch([{ type: types.LOADING_COMPLEMENTO, payload: false }]);
      }
    );
  };
};

export const excluircomplemento = () => {
  const { complemento_filtro, complemento } =
    store.getState().empresa_complementos;
  return new Promise((resolve, reject) => {
    http.delete(`/api/v2/empresa/produto/complementos/${complemento.id}`).then(
      (response) => {
        store.dispatch([
          { type: types.LOADING_COMPLEMENTO, payload: true },
          pesquisarComplementos(complemento_filtro),
        ]);
        resolve();
      },
      (error) => {
        store.dispatch([{ type: types.LOADING_COMPLEMENTO, payload: false }]);
        reject(error);
      }
    );
  });
};

export const imagensProduto = (produto_id) => {
  return (dispatch) => {
    http.get(`/api/v2/empresa/produto/imagens/${produto_id}`).then(
      (resp) => {
        dispatch({
          type: types.SET_IMAGENS_PRODUTO,
          payload: resp.data,
        });
      },
      (error) => {
        console.log(error);
      }
    );
  };
};

export const uploadImagemProduto = (produto_id, file) => {
  return new Promise((resolve, reject) => {
    http.post(`/api/v2/empresa/produto/imagens/${produto_id}`, { file }).then(
      (response) => {
        resolve();
      },
      (error) => {
        reject();
      }
    );
  });
};

export const atualizarImagemProduto = (id, file) => {
  return new Promise((resolve, reject) => {
    http.put(`/api/v2/empresa/produto/imagens/${id}`, { file }).then(
      (response) => {
        resolve();
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const removerImagemProduto = (id) => {
  return new Promise((resolve, reject) => {
    http.delete(`/api/v2/empresa/produto/imagens/${id}`).then(
      (response) => {
        resolve();
      },
      (error) => {
        reject(error);
      }
    );
  });
};
